import { z as zod } from 'zod';
import { HeroIntroSchema } from '@/app/features/shared/intros/hero/types/HeroIntro.schema';
import { RelatedInfoSchema } from '@/app/features/shared/types/schema';

export const SiteShopSchema = zod.object({
    intro: HeroIntroSchema,
    companion: zod.string().nullish(),
    relatedInfos: zod.array(RelatedInfoSchema),
});

export type SiteShopEditable = zod.infer<typeof SiteShopSchema>;
